/** @type {WeakMap<HTMLElement, () => void>} */
const resizeHandlers = new WeakMap();

/**
 * Set every pricing plan card to the height of the tallest card.
 * @param {HTMLElement} section
 */
export function equalizePricingPlanHeights(section) {
	const plans = [...section.querySelectorAll('.pricing__plan')];
	if (!plans.length) {
		return;
	}

	plans.forEach((plan) => {
		plan.style.minHeight = '';
	});

	const maxHeight = Math.max(
		...plans.map((plan) => Math.ceil(plan.getBoundingClientRect().height)),
		0,
	);

	if (maxHeight > 0) {
		const heightPx = `${maxHeight}px`;
		plans.forEach((plan) => {
			plan.style.minHeight = heightPx;
		});
	}
}

/**
 * @param {HTMLElement} section
 */
function bindEqualHeightResize(section) {
	const existing = resizeHandlers.get(section);
	if (existing) {
		window.removeEventListener('resize', existing);
	}

	let frame = 0;
	const onResize = () => {
		cancelAnimationFrame(frame);
		frame = requestAnimationFrame(() => equalizePricingPlanHeights(section));
	};

	resizeHandlers.set(section, onResize);
	window.addEventListener('resize', onResize, { passive: true });
}

export function initPricingPlansEqualize() {
	document.querySelectorAll('.js-pricing-section').forEach((section) => {
		bindEqualHeightResize(section);

		if (typeof ResizeObserver !== 'undefined') {
			const observer = new ResizeObserver(() => {
				requestAnimationFrame(() => equalizePricingPlanHeights(section));
			});
			section.querySelectorAll('.pricing__plan-body').forEach((body) => observer.observe(body));
		}

		requestAnimationFrame(() => equalizePricingPlanHeights(section));
	});
}
